/**
 * The base class for all models
 */
export default class IModel {


    /**
     * Create a new  object
     * @param params
     */
    constructor(...params) {
    }

};
